module.exports = __webpack_public_path__ + "static/img/2.5b1333f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/common/document/3/2.png
// module id = aMGj
// module chunks = 1